import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "51",
  height: "44",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"12\" height=\"12\" x=\".083\" fill=\"#528BFF\" rx=\"4\"></rect><rect width=\"34.5\" height=\"12\" x=\"16.084\" fill=\"#528BFF\" rx=\"4\"></rect><rect width=\"12\" height=\"12\" x=\".083\" y=\"16\" fill=\"#EAECF0\" rx=\"4\"></rect><rect width=\"34.5\" height=\"12\" x=\"16.084\" y=\"16\" fill=\"#EAECF0\" rx=\"4\"></rect><rect width=\"12\" height=\"12\" x=\".083\" y=\"32\" fill=\"#EAECF0\" rx=\"4\"></rect><rect width=\"34.5\" height=\"12\" x=\"16.084\" y=\"32\" fill=\"#EAECF0\" rx=\"4\"></rect>", 6)
  ])))
}
export default { render: render }